import { memo } from "react";
import ToastMessage from "~/common/components/Messages/ToastMessage/ToastMessage";
import { useTranslation } from "react-i18next";
import { Button, Card, Stack, styled, Typography } from "@schaeffler-commerce/design-system";
import { C_PRIMARY_CONTAINER } from "@schaeffler-commerce/design-system";
import { IMG_LINK_EXPIRED } from "~/utils/url/staticResources";

interface Props {
  errors: string[];
  imageSrc?: string;
  onSignUpClick?: () => void;
}

const ExpiredLinkPage = ({ errors, imageSrc, onSignUpClick }: Props) => {
  const { t } = useTranslation();

  return (
    <StyledCard>
      {errors.map((err) => (
        <ToastMessage type={"error"} key={err}>
          {t(err)}
        </ToastMessage>
      ))}
      <IconContainer>
        <ExpiredLinkImage src={imageSrc ?? IMG_LINK_EXPIRED} alt={t("page.expiredLink.iconAlt")} />
      </IconContainer>
      <Stack sx={{
        gap: 3
      }}>
        <Typography variant="headlineMedium" sx={{
          textAlign: "center"
        }}>
          {t("page.expiredLink.title")}
        </Typography>
        <Stack sx={{
          gap: 1
        }}>
          <Typography variant="bodyLarge" sx={{
            textAlign: "center"
          }}>
            {t("page.expiredLink.subtitle.one")}
          </Typography>
          <Typography variant="bodyLarge" sx={{
            textAlign: "center"
          }}>
            {t("page.expiredLink.subtitle.two")}
          </Typography>
        </Stack>
        <Button variant="text" data-test-id={"expired-registration-button"} onClick={onSignUpClick}>
          {t("page.expiredLink.signup")}
        </Button>
      </Stack>
    </StyledCard>
  );
};

export default memo(ExpiredLinkPage);

const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  width: "386px",
  padding: "24px",
  flexDirection: "column",
  margin: "64px auto",
  alignItems: "center",
  gap: "32px",
  [theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

const IconContainer = styled("div")({
  display: "flex",
  padding: "12px",
  alignItems: "center",
  gap: "8px",
  borderRadius: "50%",
  backgroundColor: C_PRIMARY_CONTAINER,
});

const ExpiredLinkImage = styled("img")({
  height: "40px",
  width: "40px",
});
